<template>
  <span
    v-if="getProgress() === 100"
    class="relative flex items-center justify-center w-12 h-12 p-2 bg-green-500 rounded-full shadow-md"
  >
    <mia-streamline-icon
      src="check-circle"
      class="w-6 h-6 text-white fill-current"
    />

    <transition
      enter-class="transform translate-y-8 opacity-0"
      enter-active-class="transition-all duration-1000 ease-out-fast"
      enter-to-class="transform translate-y-0 opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition-opacity duration-500 ease-out-fast"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isSuccessNotificationVisible"
        class="absolute px-4 py-2 -mt-12 text-white bg-green-600 rounded-full shadow-xl"
      >
        Super!
      </div>
    </transition>
  </span>
  <vue-radial-progress-bar
    v-else
    :completed-steps="getProgress() === 0 ? 5 : getProgress()"
    :diameter="50"
    :stroke-width="3"
    :total-steps="100"
    inner-stroke-color="transparent"
    start-color="#48bb78"
    stop-color="#48bb78"
  >
    <span
      class="text-xs text-gray-700"
    >
      {{ getProgress() }}<span class="text-xs">%</span>
    </span>
  </vue-radial-progress-bar>
</template>

<script>
import get from 'lodash/get'
import RadialProgressBar from 'vue-radial-progress'
import { mapGetters } from 'vuex'

export default {
  name: 'MiaCarEditSectionProgress',

  components: {
    'vue-radial-progress-bar': RadialProgressBar
  },

  props: {
    group: {
      type: String,
      default: 'caredit'
    },

    page: {
      type: String,
      required: true
    },

    section: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isSuccessNotificationVisible: false
    }
  },

  computed: {
    ...mapGetters('progress', ['progress']),

    currentProgress() {
      if (!this.progress || !this.progress[this.group] || !this.progress[this.group].section || !this.progress[this.group].section[`${this.page}.${this.section}`]) {
        return 0
      }

      return this.progress[this.group].section[`${this.page}.${this.section}`].progress
    }
  },

  watch: {
    currentProgress(progress, oldProgress) {
      if (progress !== oldProgress && progress === 100) {
        this.$nextTick(() => {
          this.showSuccessNotification()
        })
      }
    }
  },

  methods: {
    getProgress(progress = this.progress) {
      const result = get(progress, [this.group, 'section', `${this.page}.${this.section}`], {})

      return result.progress || 0
    },

    showSuccessNotification(timeout = 3000) {
      this.isSuccessNotificationVisible = true

      setTimeout(() => {
        this.isSuccessNotificationVisible = false
      }, timeout)
    }
  }
}
</script>
